var map = {
	"./1000_gold.png": 9062,
	"./10_silver.png": 8034,
	"./1_bronze.png": 4384,
	"./beginer.png": 858,
	"./black.png": 5869,
	"./bronze.png": 7854,
	"./comment.png": 1185,
	"./god.png": 8784,
	"./gold.png": 7963,
	"./huri.png": 7934,
	"./numa.png": 1719,
	"./obi.png": 6757,
	"./obiBlack.png": 3174,
	"./photo.png": 7724,
	"./silver.png": 7682,
	"./speaker.png": 6121,
	"./sushi.png": 7922,
	"./waku0.png": 1689,
	"./waku1.png": 1086,
	"./waku2.png": 9158,
	"./waku3.png": 3416,
	"./waku4.png": 4759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3530;